import { Component, Inject, Optional } from '@angular/core';
import { DocumentUploadContractType } from '../../../../../models/enums/document-upload-contract-type';
import { ServerApiService } from '../../../../../server-api/server-api.service';
import { LogService } from '../../../../../services/log/log.service';
import { ToasterService } from '../../../../../shared-components/custom-toaster/toaster.service';
import { UtilitiesService } from '../../../../../services/utils/utilities.service';
import { OperationResult } from '../../../../../models/server-result/operation-result';
import { DocumentRecordsUploadTemplateResult } from '../../../../../models/upload/documents/document-records-upload-template-result';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from '../../../../../services/translate/translate.service';
import { CUSTOM_MODAL_DATA } from '../../../../../shared-components/custom-modal/custom-modal.types';

interface DocumentsUploadInstructionsModalData {
	uploadContractType: DocumentUploadContractType | null;
}

@Component({
	selector: 'eif-documents-upload-instructions-modal',
	templateUrl: './instructions-modal.component.html',
	styleUrls: ['./../documents-upload.scss'],
	standalone: false,
})
export class DocumentsUploadInstructionsModalComponent {
	uploadContractType: DocumentUploadContractType | null = null;

	constructor(
		@Optional() @Inject(CUSTOM_MODAL_DATA) modalData: DocumentsUploadInstructionsModalData | null,
		private serverApiService: ServerApiService,
		private logger: LogService,
		private toasterService: ToasterService,
		private utilitiesService: UtilitiesService,
		private translateService: TranslateService
	) {
		this.uploadContractType = modalData?.uploadContractType ?? null;
	}

	protected downloadTemplate() {
		this.serverApiService.generateDocumentRecordsUploadTemplate(this.uploadContractType!).subscribe({
			next: (operationResult: OperationResult<DocumentRecordsUploadTemplateResult>) => {
				if (operationResult.IsValid) {
					const blob = this.utilitiesService.base64ToBlob(operationResult.Data.Content, operationResult.Data.ContentType);

					//strategy from https://stackoverflow.com/questions/19327749/javascript-blob-filename-without-link
					const element = document.createElement('a');
					element.href = URL.createObjectURL(blob);
					element.download = operationResult.Data.ContentName;
					document.body.appendChild(element);
					element.click();
				} else {
					this.toasterService.showError(this.translateService.translate('VALIDATION_FAILED', 'list-errorCodes'), {
						errors: operationResult.Errors,
						autoClose: false,
					});
				}
			},
			error: (httpErrorResponse: HttpErrorResponse) => {
				this.logger.error('[DocumentsUploadStep1Component::generateDocumentRecordsUploadTemplate] HttpErrorResponse: ', httpErrorResponse);
				this.toasterService.showError(
					'[DocumentsUploadStep1Component::generateDocumentRecordsUploadTemplate] HttpErrorResponse: ' +
						httpErrorResponse.error +
						httpErrorResponse.message
				);
			},
		});
	}

	protected showConfirmingUploadInstructions(): boolean {
		return this.uploadContractType === DocumentUploadContractType.Confirming;
	}

	protected showFactoringUploadInstructions(): boolean {
		return this.uploadContractType === DocumentUploadContractType.Factoring;
	}

	public start(): string {
		return 'Ok pressed';
	}
}
